import { useEffect, useState } from 'react';
import { STICKY_AD_SPACING } from 'constants/ads';

function useStickyOptions(_ref) {
  let {
    isSticky,
    isRailsComponent,
    parentElement
  } = _ref;
  const {
    0: stickyOptions,
    1: setStickyOptions
  } = useState();
  useEffect(() => {
    var _document$querySelect;

    if (!document || !isSticky) {
      setStickyOptions(undefined);
      return;
    }

    const headerHeight = ((_document$querySelect = document.querySelector('.js-header')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight) || 0;
    setStickyOptions({
      offset: headerHeight + STICKY_AD_SPACING
    });
  }, [isSticky]);
  useEffect(() => {
    // This is needed while we use react-on-rails
    // to output our React components
    //
    // TODO: Remove after we move to next.js
    if (!isRailsComponent || !parentElement || !stickyOptions) return; // eslint-disable-next-line no-param-reassign

    parentElement.style.top = "".concat(stickyOptions.offset, "px");
    parentElement.classList.add('ad-sticky');
  }, [isRailsComponent, parentElement, stickyOptions]);
  return stickyOptions;
}

export default useStickyOptions;